import APICall from 'store/APIClient';

export const EMPTY_ARGUMENT_ERROR = 'error.empty_argument_export_impossible';

/** Return URL of a PDF blob. Can be used in combination with the `downloadFile` function to download a pdf:
 * const pdfBlobUrl = getURLAsPDF(someUrl);
 * downloadFile(pdfBlobUrl, title, 'pdf');
 */
export async function getUrlAsPDF(url: string): Promise<string> {
    const response = await APICall<BlobPart>({
        endpoint: url,
        method: 'GET',
        headers: { 'Cache-Control': 'no-cache' },
    });
    if (!response.ok) {
        throw new Error(
            `error while getting PDF at ${url}, reason: ${response?.content.message}`,
        );
    }

    const blob = new Blob([response.content], {
        type: 'application/pdf',
    });
    return window.URL.createObjectURL(blob);
}
